<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Pedidos</h3>
            </div>
            <div class="col-auto">
              <b-button variant="outline-dark" download="beneficios.xls" :href="`${baseURL}/api/saude/export-xls?empresa=${empresa._id}&id=${user._id}`">
                <i class="fas fa-file-excel"></i> Exportar
              </b-button>
              <b-button :to="{name: 'BeneficioForm'}">Novo</b-button>
            </div>
          </div>
        </div>

        <div class="">
          <div class="text-right">
            <b-button v-b-toggle.collapse-1 variant="primary">
              <i class="fa fa-filter"></i>
              Filtros
            </b-button>
          </div>
          <b-collapse id="collapse-1" class="mt-2">
            <b-card header="Filtros para aplicar">
              <div class="container">
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Nome</label>
                      <input type="text" class="form-control" v-model="filtro.nome">
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group" :class="{'has-danger': errors.has('titulo')}">
                      <label>Título</label>
                      <input type="text" class="form-control"
                             id="titulo" name="titulo"
                             v-model="filtro.titulo">
                      <div
                          v-if="errors.has('titulo')"
                          class="help-block form-text text-muted form-control-feedback"
                      >{{errors.first('titulo')}}</div>
                    </div>
                  </div>
                </div>
                <div class="row text-right">
                  <div class="col">
                    <b-link @click="limpar" class="mr-2">Limpar</b-link>
                    <b-button v-b-toggle.collapse-1 @click="getBeneficios" variant="primary">Aplicar</b-button>
                  </div>
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>

        <div class="mt-3">
          <b-card>
            <div class="row">
              <b-col class="my-1">
                <b-pagination
                    v-if="totalRows > 10"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="my-0"
                ></b-pagination>
              </b-col>
            </div>
            <b-table show-empty emptyText="Não há itens para exibir"
                     ref="table" id="my-table"
                     :current-page="currentPage"
                     :per-page="perPage" selectable
                     @row-selected="onRowSelected"
                     select-mode="single"
                     selected-variant="success"
                     :busy="loading" :items="beneficios"
                     :fields="fields" small
                     striped hover bordered>
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando...</strong>
              </div>
              <template slot="[permiteAcimaDe70Anos]" slot-scope="row">
                <b-badge :variant="row.item.permiteAcimaDe70Anos === true ? 'success' : 'warning'">
                  {{row.item.permiteAcimaDe70Anos === true ? 'SIM' : 'NÃO'}}
                </b-badge>
              </template>
              <template slot="[status]" slot-scope="row">
                <b-badge :variant="row.item.status === 'ATIVO' ? 'success' : 'danger'">
                  {{row.item.status}}
                </b-badge>
              </template>
              <template slot="[actions]" slot-scope="row">
                <b-button title="Editar" variant="light" @click.stop=" $router.push({name: 'BeneficioForm', query:{id: row.item._id}})">
                  <i class="fas fa-edit"></i>
                </b-button>
              </template>
            </b-table>
          </b-card>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Beneficios",
  async created() {
    await this.getBeneficios();
  },
  data: () => ({
    totalRows: 1,
    currentPage: 1,
    perPage: 10,
    beneficios: [],
    fields: [
      {key: 'permiteAcimaDe70Anos', class: 'text-center', label: 'Permite acima 70 anos', thStyle: {width: '9rem', 'text-align': 'center'}},
      {key: 'nome', label: 'Nome', thClass: 'text-center'},
      {key: 'titulo', label: 'Título', thClass: 'text-center'},
      {key: 'status', label: 'Status', class: 'text-center'},
      {key: 'actions', class: 'text-center'}
    ],
    filtro:{
      nome: null,
      titulo: null
    }
  }),
  computed: {
    baseURL(){
      return axios.defaults.baseURL;
    },
    loading() {
      return this.$store.getters.loadingTable;
    },
    empresa() {
      return this.$store.getters.empresa;
    },
    isUtilizaPlataformaPagamento() {
      return this.$store.getters.empresa.utilizaPlataformaPagamento;
    },
    isVendedor() {
      return this.$store.getters.isVendedor;
    },
    isAdministrador() {
      return this.$store.getters.isAdministrador;
    },
    isVendedorMaster() {
      return this.$store.getters.isVendedorMaster;
    },
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    async getBeneficios() {
      const beneficios = await axios.get('/api/beneficio', {
           params : this.filtro
      }).then(response => response.data);
      this.beneficios = beneficios;
    },
    limpar() {
      this.filtro = {
        nome: null,
        titulo: null
      };
    }
  }
}
</script>

<style scoped>

</style>
